export default __webpack_public_path__ + "static/media/drstile-website-3.69bde71f.webp";